<template>
  <CCard>
    <CFlex column>
      <CShelf class="c-edit-bar">
        <template #left>
          <slot name="header">
            <div
              :class="[
                'selected-asset-details__header',
                filteredData && filteredData.length > 0
                  ? 'selected-asset-details__header-padding-bottom'
                  : '',
              ]"
            >
              <h2 class="selected-asset-details__name">{{ name }}</h2>
            </div>
          </slot>
        </template>

        <template #right v-if="!readonly">
          <CButton v-if="isCancel" theme="ghost-secondary-medium" @click="$emit('cancel')">
            <CIcon name="close" />
          </CButton>
          <CButton v-else theme="ghost-primary" @click="$emit('edit')">
            <CIcon name="compose-pen" />
          </CButton>
        </template>
      </CShelf>
      <div
        v-if="filteredData.length > 0"
        class="selected-asset-details__details-container"
      >
        <div v-for="item in filteredData" class="selected-asset-details__item">
          <CValue :label="item.label ?? ''">
            {{ item.value }}
          </CValue>
        </div>
      </div>
    </CFlex>
  </CCard>
</template>

<script lang="ts" setup>
  import { computed } from 'vue';
  import CButton from '@/shared/components/buttons/CButton.vue';
  import CIcon from '@/shared/components/CIcon.vue';
  import CShelf from '@/shared/components/CShelf.vue';
  import CValue from '@/shared/components/CValue.vue';
  import CFlex from '@/shared/components/CFlex.vue';
  import CCard from '@/shared/components/CCard.vue';

  const props = defineProps<{
    name?: string;
    data: {
      label: string | undefined;
      value: string | undefined;
    }[];
    readonly?: boolean;
    isCancel?: boolean;
  }>();

  const filteredData =  computed(() => props.data?.filter((item) => item.label && item.value)) ?? [];
</script>

<style scoped lang="scss">
.selected-asset-details__header {
  display: flex;
  gap: 10px;
  align-items: center;
}

.selected-asset-details__header-padding-bottom {
  padding-bottom: 8px;
}

.selected-asset-details__edit-button {
  position: absolute;
  right: 12px;
}

.selected-asset-details__details-container {
  display: grid;
  grid-template-columns: 1fr 1fr;
  width: 100%;
}

.selected-asset-details__item {
  min-width: 0;

  :deep(.c-value-label) {
    white-space: nowrap;
  }
}

.selected-asset-details__item:nth-child(2n) {
  padding-left: 8px;
}

.selected-asset-details__item:nth-child(2n + 1) {
  border-right: 1px solid #e4ebf0;
  padding-right: 8px;
}

.selected-asset-details__item:nth-child(2n + 1):only-child {
  border-right: 1px solid #00000000;
  padding-right: 8px;
}

.c-edit-bar {
  .c-button-ghost {
    margin: -0.5rem;
  }
}
</style>
